import { formatCredits, hasEnough } from '../lib/money'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  /** Цена ЦЕЛОГО прогона из сметы. Не считается умножением на фронте. */
  price?: string
  balance?: string
  isLoading: boolean
}

/**
 * Цена прогона у кнопки запуска. Показывают две поверхности — композер главной
 * и сайдбар редактора, поэтому компонент лежит в features/ai.
 *
 * Смета не загружена — скелет, но кнопку запуска НЕ гасим: отсутствие цены не
 * повод запретить запуск (у генерации в новый курс сметы нет вовсе).
 */
export const QuotePlate = ({ price, balance, isLoading }: Props) => {
  const m = useMessages(messages)
  if (isLoading) return <div className="h-4 w-32 animate-pulse rounded bg-foreground/10" />
  if (!price) return null

  const enough = balance ? hasEnough(balance, price) : true

  return (
    <div className="flex items-center gap-2 text-xs text-muted-foreground">
      <span>{m.runPrice(formatCredits(price))}</span>
      {balance ? <span>{m.balance(formatCredits(balance))}</span> : null}
      {enough ? null : <span className="text-destructive">{m.notEnoughCredits}</span>}
    </div>
  )
}
